<div class="billing-banner" *ngIf="bannerInfo$ | async as bannerInfo">
  <span>
    <strong>{{ bannerInfo.title }}:</strong>
    {{ bannerInfo.message }}
  </span>
  <ion-button
    size="small"
    fill="outline"
    color="secondary"
    (click)="manageBilling()"
  >
    {{ bannerInfo.buttonText }}
  </ion-button>
</div>
